import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

// TODO(intools-access): replace placeholder ids with real backend-provisioned 32-hex (T002).
export const IntoolsAccessRolesRBAC = {
  pageID: '4609e37fd027333c377315cd2f88d720',
  elementID: {
    ButtonSaveEdit: '3ed5f72cd6647c1a745982dfa6e5227e',
    DeleteRole: '8d74f1d1fff61833c6101faeb92a79b9',
    ViewRoleList: 'bcb705f7ff3846a226531dfc0db84879',
    ButtonViewEditRole: '9811c052c049f290797e57691378f775',
    AddRoleButton: 'a16aab8b84d18d7da230938fbe40c0d9',
  },
} as const

export const useRBACIntoolsAccessRolesPage = createUseRBAC(IntoolsAccessRolesRBAC.elementID)

export type UseRBACIntoolsAccessRolesPageType = ReturnType<typeof useRBACIntoolsAccessRolesPage>
